import React, { useMemo } from 'react';
import { sanitizeCmsHtml } from 'src/util/sanitizeCmsHtml';

type SafeHtmlProps = {
    html?: string | null;
    className?: string;
    as?: keyof React.JSX.IntrinsicElements;
};

export const SafeHtml: React.FC<SafeHtmlProps> = ({ html, className, as: Tag = 'div' }) => {
    const innerHtml = useMemo(() => ({ __html: sanitizeCmsHtml(html) }), [html]);
    return React.createElement(Tag, {
        className,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: innerHtml,
    });
};
